module.exports = { "default": require("core-js/library/fn/number/parse-int"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/number/parse-int.js
// module id = 767
// module chunks = 0